var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgDownloadCloud = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6955 18.8687L15.2486 16.3156C15.5226 16.0415 15.9669 16.0415 16.241 16.3156C16.515 16.5896 16.515 17.0339 16.241 17.308L12.4984 21.0505C12.3603 21.1886 12.179 21.2571 11.998 21.256L11.9937 21.256C11.7668 21.256 11.5651 21.1483 11.4368 20.9813L7.76349 17.308C7.48945 17.0339 7.48945 16.5896 7.76349 16.3156C8.03753 16.0415 8.48184 16.0415 8.75588 16.3156L11.292 18.8517V12.1336C11.292 11.746 11.6062 11.4319 11.9937 11.4319C12.3813 11.4319 12.6955 11.746 12.6955 12.1336V18.8687ZM10.1237 3.054C13.3099 3.42098 15.9702 5.60989 16.9626 8.62495H17.6155C19.9623 8.62311 22.0395 10.1427 22.7484 12.3799C23.4572 14.6171 22.634 17.0557 20.7143 18.4056C20.3973 18.6285 19.9596 18.5523 19.7367 18.2353C19.5137 17.9182 19.59 17.4805 19.907 17.2576C21.3259 16.2598 21.9344 14.4574 21.4104 12.8038C20.8865 11.1502 19.3512 10.027 17.616 10.0284H16.4371C16.1168 10.0284 15.8371 9.81141 15.7574 9.50109C15.059 6.77921 12.7547 4.76977 9.96309 4.44824C7.1715 4.12671 4.47068 5.55968 3.17176 8.0515C1.87284 10.5433 2.24478 13.578 4.10701 15.6824C4.36385 15.9727 4.33678 16.4161 4.04655 16.673C3.75631 16.9298 3.31283 16.9027 3.056 16.6125C0.80847 14.0727 0.359578 10.4101 1.92724 7.40276C3.4949 4.39539 6.75451 2.66595 10.1237 3.054Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgDownloadCloud;